import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      primary: { primaryBlue3 },
      red: { red4, red5, red6 },
    },
  } = styleConfig;
  return {
    CardFront: {
      width: '288px',
      height: '186px',
      borderRadius: '10px',
      margin: '0 0 20px 0',
      overflow: 'hidden',
      marginBottom: '20px',
      position: 'relative',
      font: '12px "Arial", "Helvetica", "sans-serif"',
    },
    CardBack: {
      width: '288px',
      height: '186px',
      borderRadius: '10px',
      margin: '0 0 20px 0',
      overflow: 'hidden',
      marginBottom: '20px',
      position: 'relative',
      font: '12px "Arial", "Helvetica", "sans-serif"',
    },
    iconColor: {
      color: primaryBlue3,
    },
    ErrorMessage1: {
      fontSize: '15px',
      color: red4,
      fontWeight: 'bold',
      padding: '7px 20px',
      marginTop: 0,
      backgroundColor: red5,
      lineHeight: '15px',
    },
    CarouselWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    CarouselElements: { display: 'flex', flexDirection: 'column' },
    InActiveCard: {
      color: red6,
      textAlign: 'center',
    },
  };
};

export default styles;
